import SaveBras from "../../shared/component/save_bras/SaveBras";

export default function CreateBrasPage() {

  return <SaveBras
    title="Crear Bras"
  />

}